import { Download } from "lucide-react";
import Reveal from "../Reveal";

export default function DownloadCTA() {
  return (
    <section data-testid="download-cta" className="relative py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-navy via-blue-900 to-blue-800 px-6 sm:px-10 lg:px-14 py-10 lg:py-12">
            <div className="absolute -top-24 -right-16 h-72 w-72 rounded-full bg-white/10 blur-3xl pointer-events-none" />
            <div className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-white/5 blur-3xl pointer-events-none" />
            <div className="relative flex flex-col lg:flex-row items-center justify-between gap-8">
              <div className="flex items-center gap-5">
                <span className="hidden sm:grid h-14 w-14 place-items-center rounded-2xl bg-white/15 backdrop-blur shrink-0">
                  <Download className="h-6 w-6 text-white" />
                </span>
                <div className="text-center lg:text-left">
                  <p className="text-[11px] uppercase tracking-[0.2em] text-blue-200 font-bold">Available everywhere</p>
                  <h3 className="font-display font-black text-2xl sm:text-3xl text-white mt-1.5 tracking-tight">
                    Start Billing Smarter with FolioStax
                  </h3>
                  <p className="mt-1.5 text-sm text-blue-100/90">
                    Be among the first to run your shop on smarter billing.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-3 shrink-0">
                <a
                  href="#contact"
                  data-testid="cta-google-play"
                  className="flex items-center gap-3 rounded-xl bg-black hover:bg-black/90 text-white pl-4 pr-5 h-14 transition border border-white/10"
                >
                  <svg viewBox="0 0 24 24" className="h-7 w-7" fill="currentColor"><path d="M3.6 2.3c-.4.2-.6.6-.6 1.2v17c0 .6.2 1 .6 1.2l.1.1L13 12.1v-.2L3.7 2.3h-.1zm10.6 10.1l3.1 3.1-9.9 5.6c-.5.3-.9.3-1.3.1l8.1-8.8zm0-.6L6.1 2.9c.4-.2.8-.2 1.3.1l9.9 5.6-3.1 3.2zm4.8 4.2L15.7 13l3.3-3.3 2.4 1.4c.8.5.8 1.6 0 2.1l-2.4 1.4-.2.1z"/></svg>
                  <span className="leading-tight text-left">
                    <span className="block text-[10px] uppercase tracking-wider opacity-80">Coming soon on</span>
                    <span className="block font-display font-bold text-base">Google Play</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
